"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class GlobalService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'files';
        this.getCatalog = async (tableName) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/catalog/${tableName}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.uploadFile = async (file, location, category, rowId, name) => {
            const formData = new FormData();
            formData.append(name, file);
            formData.append('location', location);
            formData.append('category', category);
            formData.append('rowId', rowId);
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}`;
            const response = await axios_1.default.post(URL, formData, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getFile = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //No se guarda respuesta en ejecucion
        this.deleteFile = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.delete(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getOperatingUnits = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/company/campus`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.downloadFile = async (docURL) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/files/download/${encodeURIComponent(docURL)}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.GlobalService = GlobalService;
